import React from 'react';
import PropTypes from 'prop-types';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';

const Tag = ({ children, prefix, suffix, ...rest }) => (
  <Div {...rest}>
    {prefix}
    {children}
    {suffix}
  </Div>
);

Tag.propTypes = {
  children: PropTypes.node,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  bg: PropTypesRepo.bg,
  textWeight: PropTypesRepo.textWeight,
  rounded: PropTypesRepo.rounded,
};

/* eslint-disable react/default-props-match-prop-types */

Tag.defaultProps = {
  tag: 'span',
  d: 'inline-flex',
  align: 'center',
  textAlign: 'center',
  justify: 'center',
  bg: 'transparent',
  textWeight: '500',
  rounded: 'sm',
  p: { x: '1em', y: '.35em' },
  textColor: 'medium',
  textSize: 'caption',
  children: null,
  prefix: null,
  suffix: null,
};

/* eslint-enable react/default-props-match-prop-types */

export default Tag;
